<template>
    <div>
        <Breadcrumbs main="User" title="Add User" />
			<div class="container-fluid">
				<div class="row">
					<div class="col-sm-12">
						<div class="card">
							<div class="card-body">
								<form @submit.prevent="addUser" enctype="multipart/form-data">
									<div class="form theme-form">
										<div class="row">
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Name <span class="required">*</span></label>
													<!-- <input class="form-control" type="text" placeholder=""> -->
														<input v-model="user.name" class="form-control" type="text" placeholder="" v-bind:class="{ 'is-invalid': Boolean(errors.name) }" minlength="3" maxlength="100" @keypress="alphaSpacesOnly"/>
														<div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
															<p class="mb-0">{{ val }}</p>
														</div>
												</div>
											</div>
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Phone <span class="required">*</span></label>
													<!-- <input class="form-control" type="text" placeholder=""> -->
														<input v-model="user.phone" class="form-control" type="text" placeholder="" v-bind:class="{ 'is-invalid': Boolean(errors.phone) }" maxlength="10" @keypress="numbersOnly"/>
														<div v-for="(val, index) in errors.phone" :key="index" class="invalid-feedback">
															<p class="mb-0">{{ val }}</p>
														</div>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Email</label>
													<!-- <input class="form-control" type="text" placeholder=""> -->
													<input class="form-control" type="text" placeholder="" v-model="user.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"/>
													<div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Password <span class="required">*</span></label>
													<!-- <input class="form-control" type="password" placeholder=""> -->
													<input class="form-control" placeholder="" type="password" v-model="user.password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }" maxlength="16"/>
													<div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Confirm Password <span class="required">*</span></label>
													<!-- <input class="form-control" type="password" placeholder=""> -->
													<input class="form-control" type="password" placeholder="" v-model="user.password_confirmation" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"  maxlength="16"/>
													<div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">User Image <span>[Allowed Formats: jpg, jpeg, png]</span></label>
													<!-- <input class="form-control" type="file" placeholder=""> -->
													<input ref="fileinput" id="fileinput" type="file" @change="setFile" accept="image/*" class="form-control image-class" v-bind:class="{ 'is-invalid': Boolean(errors.image) }" />
													<div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
													
													<img class="image-preview" v-bind:src="preview_image">
												</div>
											</div>
										</div>
										<div class="col-sm-6">
											<!-- <a class="btn btn-primary me-3" type="submit">Add</a>
											<a class="btn btn-light" >Cancel</a> -->
											<button type="submit" class="btn btn-primary me-3">Add</button>
											<button class="btn btn-light" @click="clearForm()">Reset</button>
										</div>
										<projectForm />
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>

	</div>
</template>


<script>
	export default {
		name: "AddUserPage",
		data() {
			
			return {
				user: {
					id: null,
					name: "",
					email: "",
					phone: "",
					password: "",
					password_confirmation: "",
					image: '',
				},
				preview_image: null,
				token: "",
				errors: {},
			};
		},
		mounted() {},

		created() {},

		methods: {
			numbersOnly(event) {
		      let keyCode = event.keyCode;
		      if (keyCode < 48 || keyCode > 57) {
		        event.preventDefault();
		      }
		    },
		    alphaSpacesOnly(event) {
		    	let keyCode = event.keyCode;
			    if ((keyCode >= 65 && keyCode <= 90) || 
			    	(keyCode >= 97 && keyCode <= 122) ||			    	
			    	(keyCode == 32)) {
			        return;
			    } else {
			    	event.preventDefault();
			    }
		    },
		   
			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.admin = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },


			setFile(event) {
				this.user.image = event.target.files[0];
				this.preview_image = URL.createObjectURL(this.user.image);		
			},

			addUser() {

				this.getToken();
				let formData = new FormData();
				formData.append("name", this.user.name);
				formData.append("email", this.user.email);
				formData.append("phone", this.user.phone);
				formData.append("password", this.user.password);
				formData.append("password_confirmation", this.user.password_confirmation);
				formData.append("image", this.user.image);

				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};
				let url;
				url = "/api/admin/users/add";

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.clearForm();
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								console.log(error.response.data);
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			clearForm() {
				this.user.name = "";
				this.user.email = "";
				this.user.phone = "";
				this.user.password = "";
				this.user.password_confirmation = "";
				this.user.image = null;
				this.preview_image = null;
				this.errors = {};
				document.getElementById('fileinput').value = '';
			},
		},
	};
</script>
